import { default as module } from './AbstractModule';
import { serializeArray } from '../utils/html'

const MSG_TYPE = {
    SUCCESS: 'success',
    ERROR: 'error'
}

const SUBMIT_LABEL = 'Submit'

export default class extends module {
    constructor(m) {
        super(m);

        // this.events = {
        //     change: {
        //         input: 'onInputBlur'
        //     }
        // }

        this.overlay = this.$('overlay')
        this.msgTitle = this.$('msgtitle')
        this.msgContent = this.$('msgcontent')
        this.msgError = this.$('msgerror')
        this.cta = this.$('cta')
        this.captchaId = null
        this.captcha = this.$('captcha')
        this.captchaKey = this.getData('sitekey');
        this.inputs = this.$('input')

        this.overlayActive = false
    }

    init() {
        this.onSubmitBind = this.onSubmit.bind(this)
        this.el.addEventListener('submit', this.onSubmitBind)

        this.inputBlurBind = this.onInputBlur.bind(this)
        for(let field of Array.from(this.inputs)) {
            field.addEventListener('blur', this.inputBlurBind)
        }
    }

    onInputBlur(e) {
        if(e.currentTarget.value.length > 0)
            e.currentTarget.classList.add('is-filled')
        else
            e.currentTarget.classList.remove('is-filled')
    }

    onSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        if(this.overlayActive) {
            this.overlay.classList.remove('is-active')
            this.overlayActive = false

            this.cta.innerText = SUBMIT_LABEL

            document.activeElement.blur()

            this.call("setActive", false, "Rainmoji", "form")

            return false
        }

        this.el.classList.add('is-loading')

        if(this.validate()) {
            if (this.captchaId === null && this.captcha) {
                this.captchaId = window.grecaptcha.render(this.captcha, {
                    sitekey : this.captchaKey,
                    size    : 'invisible',
                    callback: (token) => {
                        this.sendData();
                    }
                });
                window.grecaptcha.execute(this.captchaId);
            } else {
                window.grecaptcha.reset(this.captchaId);
                window.grecaptcha.execute(this.captchaId);
            }
        } else {
            this.onError({ message: "Error 400 : Bad request. Some required fields are not filled properly." });
        }

        document.activeElement.blur()
    }

    sendData() {
        var fd = new FormData();
        let data = serializeArray(this.el);
        for (var key in data) {
            fd.append(data[key]['name'], data[key]['value']);
        }

        $.ajax({
            url: this.el.getAttribute('action'),
            type: 'post',
            data: fd,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: (response) => {
                if(!response.success) {
                    this.onError(response);
                } else{
                    this.onSuccess(response);
                }
            },
            error: (response) => {
                this.onError(response);
            }
        });
    }

    onSuccess(response) {
        this.call("resize", null, "Rainmoji", "form")
        this.call("setActive", true, "Rainmoji", "form")

        this.el.classList.remove('is-loading')

        this.message({
            title: "Message Sent!",
            content: "Thank you for reaching out!<br>We'll get back to you within 24 hours.",
            cta: "Send another message (Don't be shy)"
        })

        document.activeElement.blur()
    }

    onError(response) {
        this.el.classList.remove('is-loading')

        let errors = []
        if(response.errors && response.errors.length) response.errors.forEach(error => errors.push(error))
        if(response.message) errors.push(response.message)

        this.message({
            title: "An error occured",
            content: "Please try again and make sure to fill all required fields.<br>If it doesn't work, please reach us by mail or phone.",
            errors,
            cta: "Try again"
        }, MSG_TYPE.ERROR)

        document.activeElement.blur()
    }

    message(msg, type = MSG_TYPE.SUCCESS) {
        this.overlayActive = true
        this.overlay.classList.add('is-active')

        let title
        if(type == MSG_TYPE.ERROR) {
            title = `<span class="o-emojied is-active"><span class="o-emojied_icon -warning"></span><span class="o-emojied_content">${msg.title}</span></span>`
        } else {
            title = msg.title
        }

        this.msgTitle.innerHTML = title
        this.msgContent.innerHTML = msg.content

        if(msg.errors && msg.errors.length) {
            this.msgError.innerHTML = ''
            for(let error of msg.errors) {
                this.msgError.innerHTML+= error+'<br>'
            }
        } else {
            this.msgError.innerHTML = ''
        }

        this.cta.innerText = msg.cta

        if(type == MSG_TYPE.SUCCESS)
            this.reset()

    }

    /**
     * Validate the form
     * Custom validation
     *
     * @return boolean
     */
    validate() {
        // Required fields that are visible, meaning that are mandatory for the current category.
        let requiredFields = Array.from(this.$('input')).filter(candidate => this.getData('required', candidate) != undefined)

        for(let el of requiredFields)
            el.classList.remove('-invalid');

        let errors = false;
        requiredFields.forEach((el, i) => {
            let $target = $(el);

            switch ($target.attr('type')) {
                case 'checkbox':
                    if (!$target[0].checked) {
                        $target.addClass('-invalid');
                        errors = true;
                    }
                    break;

                case 'tel':
                    let valid = false

                    let val = $target.val()
                    if(val && val.length && /\d/.test(val)) valid = true

                    if(!valid) {
                        $target.addClass('-invalid');
                        errors = true;
                    }
                    break;

                default:
                    if (!$target.val()) {
                        $target.addClass('-invalid');
                        errors = true;
                    }
                    break;
            }
        });

        return !errors;
    }

    reset() {
        this.el.reset()
        for(let i = 0; i < this.el.length; i++) {
            this.el[i].classList.remove('is-filled')
        }
    }

    destroy() {
        this.el.removeEventListener('submit', this.onSubmitBind)

        for(let field of Array.from(this.inputs)) {
            field.removeEventListener('blur', this.inputBlurBind)
        }
    }
}
